<template>
  <div class="row marketing">
    <div class="col-lg-12" v-for="item in getCourseData">        
      <div v-html="item.introductionText"></div>
      <h4 style="margin-bottom: 1em;">Chapter</h4>
      <div v-for="item2 in item.chapter" style="margin-left: 1em;margin-bottom: 1em;">
        <h5 style="margin-bottom: -1em;">{{ item2.chapterName }} <span style="color: rgba(0, 0, 0, 0.2)"></span></h5><br> 
        <div style="color:rgba(0,0,0,.2); font-weight:bold">
          <span><i class="fa fa-clock-o fa-lg" aria-hidden="true"></i> ~{{ item2.chapterTime }} min</span>
          <span style="color:#f2c300"><span style="margin-top: -4px; margin-right: -2px;" class="coinicon3"></span> {{ item2.assignmentPoints }} LPs</span>
        </div>
        <p>{{ item2.chapterShortDescription }} Solve the assignment to earn {{ item2.assignmentPoints }} Learning Points.</p>
      </div>
      <h4>Author</h4>
      <p>{{ item.authorDescription }}</p>
      <a class="btn btn-outline-primary btn-lg btn-block" @click="StartCourse(item.id)">
        Start now
      </a>
    </div>
  </div>
</template>

<script>
import { store } from '../../store/store.js'

export default {
  methods: {
    StartCourse(courseId) {
      store.dispatch('setChapter', 0);
      this.$router.push({path: '/course/' + courseId + '/chapter/0/materials/'})
    }
  },
  computed: {
      getCourseData() {
        return this.$store.getters.getLCData
      }
  }
}
</script>

<style>
.btn-outline-primary:hover {
    color: #fff!important;
    background-color: #6AD5BF;
    border-color: #65CB99;
}

.btn-outline-primary {
    color: #6AD5BF!important;
    border-color: #6AD5BF;
}

</style>


// WEBPACK FOOTER //
// src/components/course/CourseIntroduction.vue